import { render, staticRenderFns } from "./Derivative.vue?vue&type=template&id=53f55df9&scoped=true&"
import script from "./Derivative.vue?vue&type=script&lang=ts&"
export * from "./Derivative.vue?vue&type=script&lang=ts&"
import style0 from "./Derivative.vue?vue&type=style&index=0&id=53f55df9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f55df9",
  null
  
)

export default component.exports